function mapEvent(mapType, options, history, dashboardType) {
  let stateDash = dashboardType.toLowerCase() + 'statedashboard'
  let msaDash = dashboardType.toLowerCase() + 'msadashboard'
  let zip3Dash = dashboardType.toLowerCase() + 'zip3dashboard'
   let countyDash = dashboardType + 'countydashboard'
  let nodata=dashboardType.toLowerCase()==='birthtrend'&&options.geo_id==='DC'?true:false
  let hash = undefined
  if(nodata)return
  if (mapType !== undefined && (mapType === 'rsvmap' || mapType==='countymap') && 'state' in options) 
    {
      hash = `/${stateDash}/state/${options.state.toLowerCase()}`
      history(hash)
    }
  else if (
    mapType === 'rsvmapmsa' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {  
    hash = `/${msaDash}/${options.geo_parent.split(',')[0].toLowerCase()}/msa/${options.state}`
    history(hash)
  } else if (
    mapType === 'rsvmapmsa' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/${stateDash}/state/${options.state.toLowerCase()}`
  } else if (
    mapType === 'rsvmapcdo' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {    
    window.location.href = `/${msaDash}/${options.geo_parent.split(',')[0].toLowerCase()}/msa/${options.state}`
  } else if (
    mapType === 'rsvmapcdo' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/${stateDash}/state/${options.state.toLowerCase()}`
  } else if (
    mapType === 'zip3map' &&
    'state' in options &&
    options.forecast_level <= 0
  ) {
  } else if (
    mapType === 'zip3map' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    window.location.href = `/${zip3Dash}/${options.geo_parent.toLowerCase()}/zip3/${options.state.toLowerCase()}`
  }
  else if (
    mapType === 'zip3map' &&
    dashboardType === 'allergies' &&
    'state' in options
  ) {
    window.location.href = `/${stateDash}/state/${options.state.toLowerCase()}`
  }
  else if (
    mapType === 'zip3map' &&
    'state' in options
  ) {
    window.location.href = `/fluzip3dashboard/${options.state.toLowerCase()}/zip3`
  }
  else if (
    mapType === 'countymap' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    window.location.href = `/${countyDash}/${options.geo_parent}/county/${options.state}`
  }
  else if (
    mapType === 'countymapmsa' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    window.location.href = `/${countyDash}/${options.geo_parent.toLowerCase()}/county/${options.state}`
   
  }
  else if (
    mapType === 'countymapmsa' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
     window.location.href =`/${stateDash}/state/${options.state.toLowerCase()}`
   
  }
}

export default mapEvent
